import React from 'react'

import { PriceString } from '@fourthwall/components'

import * as S from './Award.styled'

export const Award = (bonus: { value: number; currency: string; text?: string }) => {
  return (
    <S.Award>
      +<PriceString value={bonus.value} currency={bonus.currency} /> {bonus.text || ''}
    </S.Award>
  )
}
